import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./pages/Auth/Login/Login";
import { ForgotPasword } from "./pages/Auth/ForgotPasword/ForgotPasword";
import { Dashboard } from "./pages/Dashboard/Dashboard";
import { ResetPasword } from "./pages/Auth/ResetPasword/ResetPasword";
import { ViewProduct } from "./pages/Dashboard/ViewProduct/ViewProduct";
import { AppList } from "./pages/Dashboard/AppList/AppList";
import AuthRoute from './AuthRoute';

export const Router = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPasword />} />
      <Route path="/reset-password" element={<ResetPasword />} />

      {/* Protected Routes */}
      <Route element={<AuthRoute />}>
        <Route path="/" element={<Dashboard />}>
          <Route path="/" element={<Navigate to="/dashboard/app-list" />} />
          <Route path="/dashboard/app-list" element={<AppList />} />
          <Route path="/dashboard/app-view" element={<ViewProduct />} />
        </Route>
      </Route>


      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};
